import { call, put } from 'redux-saga/effects';
import UserClient from '../../api/UserClient';
import { setOngoingTrips, setOngoingTripsLoading } from '../../redux/user/actions';
import { messagesShow } from '../../redux/messages/actions';

export function* getOngoingTripsSaga() {
    try {
        const { journeys } = yield call(UserClient.getOngoingTrips);
        if (!Array.isArray(journeys)) {
            return;
        }
        yield put(
            setOngoingTrips({
                ids: journeys.map(journey => journey.id),
                data: journeys.reduce((acc, journey) => {
                    acc[journey.id] = journey;
                    return acc;
                }, {}),
            })
        );
    } catch (error) {
        console.error('Error in getOngoingTripsSaga:', error);
        yield put(messagesShow('billingPage.ongoingTripsPage.notifications.receiptsFetchError', 'error'));
    } finally {
        yield put(setOngoingTripsLoading(false));
    }
}
